var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.9,
    height: 32.9,
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 11.27v3.61-3.61zv11.54-.17.17-11.54zm0 12.98q-.57 0-.98-.43t-.41-1.02V11.26q0-.59.41-1.02t.98-.43h4.99q.28 0 .53.11t.44.31l3.37 3.49q.19.2.29.46t.1.55v2.55q-.33-.12-.67-.19t-.72-.06v-2.16h-2.09q-.57 0-.98-.43t-.41-1.02v-2.16h-4.87V22.8h4.41q.14.41.35.78t.49.66h-5.25zm8.34-1.86-.97 1q-.19.19-.48.21t-.49-.21q-.19-.2-.19-.5t.19-.5l.97-1.01-.97-1.01q-.19-.2-.19-.5t.19-.5q.19-.2.49-.2t.49.2l.97 1.01.97-1.01q.19-.2.48-.21t.49.21q.19.19.19.5t-.19.5l-.96 1.01.96 1.01q.19.19.2.5t-.2.51q-.19.19-.49.19t-.49-.19l-.97-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.999 30.594a16.3 16.3 0 1 1 22.13-5.93 16.3 16.3 0 0 1-22.13 5.93zM24.769 3.28a15.34 15.34 0 1 0 5.615 20.955A15.34 15.34 0 0 0 24.769 3.28z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveElement);
export default __webpack_public_path__ + "static/media/remove_element.30560078250fea89d8cd12fa0258465a.svg";
export { ForwardRef as ReactComponent };